module.exports = __webpack_public_path__ + "img/dfjw2.8812f6f0.jpg";